import { createContext, type PropsWithChildren, useMemo, useState } from 'react';

export type UrlSearchStateContextValue = {
  isSetStateFromUrlDone: boolean;
  isReflectToUrlDone: boolean;
  setIsSetStateFromUrlDone: (value: boolean) => void;
  setIsReflectToUrlDone: (value: boolean) => void;
};

export const UrlSearchStateContext = createContext<UrlSearchStateContextValue | undefined>(undefined);

/**
 * Per-SearchModule URL sync readiness. Must stay instance-scoped — a module-global
 * flag races on remounts (e.g. header language change).
 */
export const UrlSearchStateProvider = ({ children }: PropsWithChildren) => {
  const [isSetStateFromUrlDone, setIsSetStateFromUrlDone] = useState(false);
  const [isReflectToUrlDone, setIsReflectToUrlDone] = useState(false);

  const value = useMemo(
    () => ({
      isSetStateFromUrlDone,
      isReflectToUrlDone,
      setIsSetStateFromUrlDone,
      setIsReflectToUrlDone,
    }),
    [isSetStateFromUrlDone, isReflectToUrlDone],
  );

  return <UrlSearchStateContext.Provider value={value}>{children}</UrlSearchStateContext.Provider>;
};
